module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Error-circle-4539a4992ba57540113acfb9fabe4d75.svg";